import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { exchangeSSOCode, handleAuthSuccess } from '../services/auth'

const Callback = () => {
    const navigate = useNavigate()
    const hasProcessed = useRef(false)

    useEffect(() => {
        if (hasProcessed.current) return

        hasProcessed.current = true

        exchangeSSOCode()
            .then((response) => {
                handleAuthSuccess(response.token)
                navigate('/is/home', { replace: true })
            })
            .catch((error) => {
                hasProcessed.current = false
                const errorMessage = error.response?.data?.message || 'Authentication failed'
                navigate(`/is?error=${encodeURIComponent(errorMessage)}`, { replace: true })
            })
    }, [navigate])


    return (
        <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <p>Signing you in…</p>
        </div>
    )
}

export default Callback